import React from "react";
import { getTrackByMediaTypeAndParticipant } from "../../../base/tracks";
import Avatar from "../../../base/avatar/components/Avatar";
import Video from "../../../base/media/components/Video";
import { MEDIA_TYPE } from "../../../base/media";
import { getDominantSpeakerParticipant } from "../../../base/participants";

export const audioVideoStatus = (type, id, isGallery = "", _tracks) => {
    let val;
    if (type === "video") {
        val = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.VIDEO, id);
    } else {
        val = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.AUDIO, id);
    }

    if (isGallery === "Y") {
        return val !== undefined ? val : true;
    }
    return val !== undefined ? val.muted : true;
};

function FullView({_participants,_tracks,screenSharedUserID,fireGroupParticipants}) {  
    const isDominant = getDominantSpeakerParticipant(APP.store.getState())
    return (
        <div className="galleryWrap">
            <div className={`galleryRow`}>
                {
                    <div className={`d-flex galleryView h-100 `}>
                        {_participants.length > 0 && _participants .filter((v) => v.id !== undefined) .map((val, index) => {  
                            let trackVideoStatus = audioVideoStatus( "video", val.id, "Y", _tracks );
                            let access = fireGroupParticipants?.[val.id]?.owner ? "Host" :"";
                            let videoTrack = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.VIDEO, val.id);  
                            if(screenSharedUserID){
                                if(val.id === screenSharedUserID){   
                                    //full view of user screen share 
                                    let name = val.name && val.name.split(" ")
                                    return ( 
                                        <span className={`full-view`} >  
                                            <Video
                                                className={`video-input-preview-display flipVideoY largeVideoTags ${videoTrack?.videoType === 'desktop' ? "object-fit-contain" : "video-view-transform"}`}
                                                videoTrack={{ jitsiTrack: trackVideoStatus.jitsiTrack }}
                                            /> 
                                            <div className="screen-share-name-div">
                                                <span>{`Viewing ${name[0]}'s screen`}</span>
                                            </div>
                                        </span> 
                                    )
                                }
                                if(val.dominantSpeaker && val.id !== screenSharedUserID ){  
                                    //bottom-left thumbnail of dominant speaker while some other user is sharing its screen
                                    return ( 
                                        <span className={`${val.dominantSpeaker ? "isDominant" : "" } dominant-video-thum`} >
                                        {access === "Host" && (
                                                <span className="participant-active-crown">
                                                    <img
                                                        src="public/assets/images/crown-img.svg"
                                                        alt="crown"
                                                    />
                                                </span>
                                            )}
                                        {trackVideoStatus.muted || trackVideoStatus.muted === undefined ? (
                                            <Avatar
                                                className={`avatar-container largeVideoTags`}
                                                participantId={val.id}
                                                size={100}
                                                displayName={val.name}
                                                url={val.avatarURL}
                                            />
                                        ) : (
                                            <Video
                                                className={`video-input-preview-display flipVideoY largeVideoTags ${videoTrack?.videoType === 'desktop' ? "object-fit-contain" : "video-view-transform"}`}
                                                videoTrack={{ jitsiTrack: trackVideoStatus.jitsiTrack }}
                                            />
                                        )}
                                        <h6 className="meeting-user-name">
                                            {`${val.name} ${access ==="Host" ? "(Host)" : ""}`}
                                        </h6>
                                    </span>  
                                    )
                                }
                            }else if(val.dominantSpeaker || (index === 0 && !isDominant) ){   
                                // if dominant speaker exist or if dominant speaker not exists then shows values of first index
                                return ( 
                                    <span className={`${val.dominantSpeaker ? "isDominant" : "" } full-view`} >
                                        {access === "Host" && (
                                                <span className="participant-active-crown">
                                                    <img
                                                        src="public/assets/images/crown-img.svg"
                                                        alt="crown"
                                                    />
                                                </span>
                                            )}
                                        {trackVideoStatus.muted || trackVideoStatus.muted === undefined ? (
                                            <Avatar
                                                className={`avatar-container largeVideoTags`}
                                                participantId={val.id}
                                                size={100}
                                                displayName={val.name}
                                            />
                                        ) : (
                                            <Video
                                                className={`video-input-preview-display flipVideoY largeVideoTags ${videoTrack?.videoType === 'desktop' ? "object-fit-contain" : "video-view-transform"}`}
                                                videoTrack={{ jitsiTrack: trackVideoStatus.jitsiTrack }}
                                            />
                                        )}
                                        <h6 className="meeting-user-name">
                                            {`${val.name} ${access === "Host" ? "(Host)" : ""}`}
                                        </h6>
                                    </span> 
                                );
                            } 
                        })}
                    </div>
                }
            </div>
        </div>
    );
}

export default FullView;
